import { Money } from '@rygen/rygen-ui/model';

export type FreightAllowanceAutoCalcStatus =
  | 'FREIGHT_ALLOWANCE_DISABLED'
  | 'AUTO_CALC_PENDING'
  | 'AUTO_CALC_COMPLETED'
  | 'AUTO_CALC_FAILED';

export class FreightAllowanceAutoCalc {
  status: FreightAllowanceAutoCalcStatus;
  suggestedAmount?: Money;

  constructor(opts?: Partial<FreightAllowanceAutoCalc>) {
    this.status = opts?.status ?? 'AUTO_CALC_PENDING';
    this.suggestedAmount = opts?.suggestedAmount
      ? new Money(opts.suggestedAmount)
      : undefined;
  }
}
